<div class="container">
  <div class="close-icon" (click)="closeDialog()">
    <img src="assets/close-icon.svg">
  </div>
  <div class="text-center">
    <div>
      <img src="assets/success-icon.svg">
    </div>
    <h1 i18n="@@thankYou">Thank you 🙏🏻</h1>
    <p i18n="@@claimBusinessMessage">We will get back to you in 2 working days.</p>
    <primary-button class="done-button" (onClick)="closeDialog()" [enabled]="true" title="{{done}}"></primary-button>
  </div>
</div>
